<template>
  <div class="app-container">
    <div class="header-row">
      <h1>Podstrony</h1>
      <div class="header-actions">
        <el-input
          v-model="query.search"
          placeholder="Szukaj po tytule lub slug-u..."
          clearable
          style="width: 280px; margin-right: 12px;"
          @clear="handleFilter"
          @keyup.enter.native="handleFilter"
        />
        <el-button type="primary" icon="el-icon-search" @click="handleFilter">Szukaj</el-button>
        <el-button v-permission="['add cms page']" type="success" icon="el-icon-plus" @click="goAdd">Dodaj podstronę</el-button>
      </div>
    </div>

    <el-table v-loading="loading" :data="list" border fit highlight-current-row style="width: 100%">
      <el-table-column align="center" label="ID" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Slug">
        <template slot-scope="scope">
          <a :href="frontendUrl + '/strony/' + scope.row.slug" target="_blank" rel="noopener">
            /strony/{{ scope.row.slug }}
          </a>
        </template>
      </el-table-column>

      <el-table-column label="Tytuł">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="Status" width="120">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.published" type="success" size="small">Opublikowana</el-tag>
          <el-tag v-else type="info" size="small">Draft</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" label="Zaktualizowano" width="180">
        <template slot-scope="scope">
          <span>{{ formatDate(scope.row.updated_at) }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="Akcje" width="320">
        <template slot-scope="scope">
          <el-button v-permission="['update cms page']" type="warning" size="small" icon="el-icon-edit" @click="edit(scope.row.id)">
            Edytuj
          </el-button>
          <el-popconfirm
            confirm-button-text="Tak"
            cancel-button-text="Nie"
            icon="el-icon-info"
            icon-color="red"
            title="Czy na pewno chcesz usunąć tę podstronę?"
            @confirm="deletePage(scope.row.id)"
          >
            <el-button slot="reference" v-permission="['delete cms page']" type="danger" size="small" icon="el-icon-delete">
              Usuń
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total > 0" :total="total" :page.sync="query.page" :limit.sync="query.limit" @pagination="getList" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import CmsPagesResource from '@/api/cmsPages';
import permission from '@/directive/permission';

const cmsPagesApi = new CmsPagesResource();

export default {
  name: 'CmsPagesList',
  components: { Pagination },
  directives: { permission },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      query: { page: 1, limit: 15, search: '' },
    };
  },
  computed: {
    frontendUrl() {
      return process.env.VUE_APP_FRONTEND_URL || 'https://dazu.pl';
    },
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        // axios interceptor (utils/request.js) zwraca response.data
        // Laravel paginator → { data: [...], total: N, current_page, per_page, ... }
        const res = await cmsPagesApi.list(this.query);
        this.list = (res && Array.isArray(res.data)) ? res.data : [];
        this.total = (res && typeof res.total === 'number') ? res.total : this.list.length;
      } catch (err) {
        this.$message.error('Nie udało się pobrać listy podstron.');
      } finally {
        this.loading = false;
      }
    },
    handleFilter() {
      this.query.page = 1;
      this.getList();
    },
    goAdd() {
      this.$router.push({ path: '/cms-pages/add' });
    },
    edit(id) {
      this.$router.push({ path: '/cms-pages/edit/' + id });
    },
    async deletePage(id) {
      try {
        await cmsPagesApi.destroy(id);
        this.list = this.list.filter(p => p.id !== id);
        this.$message.success('Podstrona usunięta.');
      } catch (err) {
        this.$message.error('Nie udało się usunąć podstrony.');
      }
    },
    formatDate(d) {
      if (!d) return '';
      try {
        const dt = new Date(d);
        return dt.toLocaleString('pl-PL');
      } catch (e) {
        return d;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  padding: 20px;
  .header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    flex-wrap: wrap;
    gap: 12px;
  }
  .header-actions {
    display: flex;
    align-items: center;
  }
}
</style>
